import React from 'react';
export const ValueStackTable = () => {
  return <section className="w-full bg-white py-8 md:py-12 px-4 md:px-6" data-id="element-261">
      <div className="max-w-[780px] mx-auto" data-id="element-262">
        <h2 className="font-playfair text-[28px] md:text-[38px] text-primary text-center mb-6" data-id="element-263">
          Everything You Get Today
        </h2>

        <div className="max-w-[680px] mx-auto border border-accent rounded-[16px] overflow-hidden" data-id="element-264">
          <div className="overflow-x-auto" data-id="element-265">
            <table className="w-full min-w-[300px] border-collapse" data-id="element-266">
              <thead data-id="element-267">
                <tr data-id="element-268">
                  <th className="bg-light text-primary font-lato font-bold text-[15px] text-left p-4 md:px-5 border-b border-accent" data-id="element-269">
                    Product
                  </th>
                  <th className="bg-light text-primary font-lato font-bold text-[15px] text-right p-4 md:px-5 border-b border-accent w-[120px]" data-id="element-270">
                    Real Value
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-271">
                <tr data-id="element-272">
                  <td className="font-lato text-[15px] text-body p-4 md:px-5 border-b border-accent" data-id="element-273">
                    Main Ebook: The Hormonal Balance Code
                  </td>
                  <td className="font-lato text-[15px] text-body p-4 md:px-5 text-right border-b border-accent" data-id="element-274">
                    $37
                  </td>
                </tr>
                <tr data-id="element-275">
                  <td className="font-lato text-[15px] text-body p-4 md:px-5 border-b border-accent" data-id="element-276">
                    Bonus 1: Hormones in the Kitchen (30 complete recipes)
                  </td>
                  <td className="font-lato text-[15px] text-body p-4 md:px-5 text-right border-b border-accent" data-id="element-277">
                    $27
                  </td>
                </tr>
                <tr data-id="element-278">
                  <td className="font-lato text-[15px] text-body p-4 md:px-5 border-b border-accent" data-id="element-279">
                    Bonus 2: The Bible of Smart Supplementation
                  </td>
                  <td className="font-lato text-[15px] text-body p-4 md:px-5 text-right border-b border-accent" data-id="element-280">
                    $37
                  </td>
                </tr>
                <tr data-id="element-281">
                  <td className="font-lato text-[15px] text-body p-4 md:px-5 border-b border-accent" data-id="element-282">
                    Bonus 3: My Transformation Journal
                  </td>
                  <td className="font-lato text-[15px] text-body p-4 md:px-5 text-right border-b border-accent" data-id="element-283">
                    $17
                  </td>
                </tr>
                <tr data-id="element-284">
                  <td className="bg-accent font-lato font-bold text-[16px] text-body p-4 md:px-5 border-b border-accent" data-id="element-285">
                    TOTAL BUNDLE VALUE
                  </td>
                  <td className="bg-accent font-lato font-bold text-[16px] text-body p-4 md:px-5 text-right border-b border-accent line-through" data-id="element-286">
                    $118
                  </td>
                </tr>
                <tr data-id="element-287">
                  <td className="bg-medium font-lato font-bold text-[20px] md:text-[24px] text-white p-4 md:px-5" data-id="element-288">
                    YOUR PRICE TODAY
                  </td>
                  <td className="bg-medium font-lato font-bold text-[20px] md:text-[24px] text-white p-4 md:px-5 text-right" data-id="element-289">
                    $27
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>;
};